import { infrastructuresRepo } from '@/constants/providers';
import { useMutation } from '@tanstack/react-query';
import { AttachCompanyInfrastructureCostModel } from '../types';

export const useAttachCompanyInfrastructureCost = () =>
  useMutation<void, unknown, AttachCompanyInfrastructureCostModel>(
    (attachCompanyInfrastructureCost) =>
      infrastructuresRepo.attachCompanyInfrastructureCost(
        attachCompanyInfrastructureCost,
      ),
  );
